module.exports = __webpack_public_path__ + "build/desktop/a/img/cross.2b0e245a1094ab1085d9ab1c392b3238.png";